import { TokenInfo } from '@/models/TokenInfo';

import UploadDonationsApp from '@/views/uploadDonations/App.vue';

export class ZgAppFactory {
    public static GetCorrectAppByToken(tokenInfo: TokenInfo) {
        if (tokenInfo.isTokenUploadDonations()) {
            return UploadDonationsApp;
        }
    }
}
